<template>
  <div>

    <nav class="navbar customNavbar" >
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItemSelected" >Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-half">
          <h2 class="title is-2">Contáctenos</h2>
          <br/>

          <h4>Llámenos al (502) 2478 - 1179 o envíenos sus preguntas o comentarios vía email. Intentaremos responder todas sus preguntas en los siguientes 2 a 3 días hábiles</h4>
          <br/>
          <form @submit.prevent="validateBeforeSubmit">
            <div class="field">
              <label class="label labelClass">Nombre</label>
              <p class="control">
                <input v-model="contact_name" v-validate="'required'" data-vv-as="nombre" :class="{'input': true, 'is-danger': errors.has('contact_name') }" type="text" name="contact_name" />
                <span v-show="errors.has('contact_name')" class="help is-danger">{{ errors.first('contact_name') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Empresa</label>
              <p class="control">
                <input v-model="contact_company" v-validate="'required'" data-vv-as="empresa" :class="{'input': true, 'is-danger': errors.has('contact_company') }" type="text" name="contact_company" />
                <span v-show="errors.has('contact_company')" class="help is-danger">{{ errors.first('contact_company') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Correo Electrónico</label>
              <p class="control">
                <input v-model="contact_email" v-validate="'required|email'" data-vv-as="correo electrónico" :class="{'input': true, 'is-danger': errors.has('contact_email') }" name="contact_email" type="email" />
                <span v-show="errors.has('contact_email')" class="help is-danger">{{ errors.first('contact_email') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Número Whatsapp</label>
              <p class="control">
                <input v-model="contact_phone" v-validate="'phone'" data-vv-as="número" :class="{'input': true, 'is-danger': errors.has('contact_phone') }" name="contact_phone" type="contact_phone" />
                <span v-show="errors.has('contact_phone')" class="help is-danger">{{ errors.first('contact_phone') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Mensaje</label>
              <p class="control">
                <textarea v-model="contact_message" v-validate="'required'" data-vv-as="mensaje" :class="{'textarea': true, 'is-danger': errors.has('contact_message') }" name="contact_message"/>
                <span v-show="errors.has('contact_message')" class="help is-danger">{{ errors.first('contact_message') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">¿Cómo prefiere que lo contactemos?</label>
              <p class="control">
                <input v-model="contact_media" name="contact_media" type="radio" /><span>&nbsp;Correo Electrónico</span>
                <span>&nbsp;</span>
                <input v-model="contact_media" name="contact_media" type="radio" /><span>&nbsp;Whatsapp</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Manténgase en contacto</label>
              <p class="control">
                <input v-model="contact_type" name="contact_type" type="checkbox" />
                <span>Enviarme información de nuevos productos y promociones en Hipromeasa</span>
              </p>
            </div>

            <div class="field is-grouped">
              <div class="control">
                <button class="button is-primary" v-on:click="send()">Enviar</button>
              </div>
            </div>
          </form>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import spanish from 'vee-validate/dist/locale/es'
import ApiClient from '@/api/ApiClient.js'
import FooterComponent from './FooterComponent'

export default {
  name: 'landing',
  components: {
    FooterComponent
  },
  data () {
    return {
      contact_name: '',
      contact_email: '',
      contact_message: '',
      contact_company: '',
      contact_phone: '',
      contact_media: '',
      contact_type: '',
      isLogged: localStorage.getItem('email') !== null
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    validateBeforeSubmit: function () {
      this.$validator.validateAll().then((result) => {
        return result
      })
    },
    send: function () {
      ApiClient.contact(this.contact_name, this.contact_email, this.contact_company, this.contact_message, this.contact_phone, this.contact_media, this.contact_type).then(response => {
        if (response.data.success) {
          alert('Información enviada exitosamente, estaremos en contacto con usted muy pronto.')
          this.$router.push('/')
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    }
  },
  created: function () {
    this.$validator.localize('es', {
      messages: spanish.messages
    })
    this.$validator.localize('es')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 80px;
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .labelClass {
    text-align: left;
  }
  .footerInfo {
    margin-left: 100px;
    margin-right:100px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:100px;
    margin-top: 60px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// ContactComponent.vue?4222734e